import React, { useEffect, useState, Fragment } from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import Wrapper from '../../components/Wrapper/Wrapper';
import { tripTableHeight, tableHeightWithSparkline } from "../../../styleVariables";
import { DataGrid } from '@material-ui/data-grid';
import ActionIconButton from '../../components/Actions/ActionIconButton';
import EditIcon from '@material-ui/icons/Edit';
import ColumnActions from '../../components/Actions/ColumnActions';
import { connect } from "react-redux";
import { logoutUser } from "../../../store/actions/authActionCreators";
import MUIDataTable from "mui-datatables";
import {
  getPartyLedgerData,
  getSinglePartyLedgerData,
  getSparklineTotalBalances
} from "../../../store/actions/homeActionCreator";
import * as logger from "../../../logger";
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import { numberFormat, vehicleNumberValidation } from '../../../utils/utils'
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import Grid from '@material-ui/core/Grid';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import VisibilityIcon from '@material-ui/icons/Visibility';
import AddParty from './AddParty';
import useStyles from '../css/listing'
import TopCard from '../../components/TopCard/TopCard'
import { trackDwebEvent } from '../../analytics';
import RollbarErrorTracking from '../../logger/RollbarErrorTracking';
import { Waypoint } from "react-waypoint";
import { debounce } from 'lodash';
import { defaultPageNo, defaultPageSize, defaultDebounceMs } from '../../../paginationVariables';
import UamPopUp from "../../components/Dialog/UamPopUp";


const Parties = ({ user, dispatchGetSparklineBalances, dispatchGetPartyLedgerAction, vehicle }) => {
  const classes = useStyles();
  let history = useHistory();
  const [partyLedgerData, setPartyLedgerData] = useState([]);
  const [addPartyModalOpen, setPartyModalOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [currentPageNo, setCurrentPageNo] = useState(1);
  const [currentPageSize, setCurrentPageSize] = useState(10);
  const [loadingText, setLoadingText] = useState("Sorry, no Parties found");
  const [uamDialogOpen, setUamDialogOpen] = useState(false);

  const partyLedgerRequestData = {
    fleetOwnerId: user && user.userInfo && user.userInfo.entityId ? user.userInfo.entityId : null,
    pageNo: defaultPageNo,
    pageSize: defaultPageSize,
  };

  useEffect(() => {

    let uamPopUp = localStorage.getItem("UamPopupShown")

    if (!uamPopUp) {
      setUamDialogOpen(true)
    }

  }, [])

  useEffect(() => {
    dispatchGetSparklineBalances(() => { }, () => { });
    dispatchGetPartyLedgerAction(partyLedgerRequestData,
      () => {
        trackDwebEvent('Dweb Parties Page', {});
        logger.log("Party Ledger", "Party Ledger Data Loading Success");
      },
      () => {
        logger.log("Party Ledger", "Party Ledger Data Loading Failure");
      }
    );
    vehicle.singleTruck = {}
  }, [
    dispatchGetPartyLedgerAction
  ]);
  useEffect(() => {
    if (user.partyLedgerData) {
      setPartyLedgerData(user.partyLedgerData);
    }
  }, [user.partyLedgerData]);
  const onSearchBlur = debounce(query => {
    setCurrentPageNo(defaultPageNo)
    dispatchGetSparklineBalances(() => { }, () => { });
    dispatchGetPartyLedgerAction({ ...partyLedgerRequestData, searchText: query },
      () => {
        trackDwebEvent('Dweb Parties Page', {});
        logger.log("Party Ledger", "Party Ledger Data Loading Success");
        setLoadingText("Sorry, no Parties found");
      },
      () => {
        logger.log("Party Ledger", "Party Ledger Data Loading Failure");
        setLoadingText("Sorry, no Parties found");
      }
    );
  }, user && user.configs && user.configs.dwebSearchBebounceMs ? parseInt(user.configs.dwebSearchBebounceMs) : defaultDebounceMs);
  const getPaginatedData = () => {
    const partyPaginatedReqData = {
      fleetOwnerId: user && user.userInfo && user.userInfo.entityId ? user.userInfo.entityId : null,
      pageNo: currentPageNo + 1,
      pageSize: currentPageSize,
      searchText: searchText,
      merge: true
    };
    dispatchGetSparklineBalances(() => { }, () => { });
    dispatchGetPartyLedgerAction(partyPaginatedReqData,
      () => {
        trackDwebEvent('Dweb Parties Page', {});
        logger.log("Party Ledger", "Party Ledger Data Loading Success");
      },
      () => {
        logger.log("Party Ledger", "Party Ledger Data Loading Failure");
      }
    );
  }
  const goToTrip = () => {
    history.push({
      pathname: '/trips/create',
      state: {
        id: 7,
        pageTitle: 'Create Trip'
      }
    });
  }
  const goToPartyView = (party) => {
    trackDwebEvent("Single Party View from Dweb", {
      party_id: party.id,
      party_name: party.partyName ? party.partyName : 'N/A'
    });
    history.push({
      pathname: `/parties/single-party/trips/${party.id}`,
      state: {
        id: 7,
        partyId: party.id || null,
        pageTitle: party.partyName ? party.partyName : 'Party View',
        openingBalanceDate: party && party.openingBalanceDate ? party.openingBalanceDate : null
      }
    });
  }
  const handleAddPartyClick = () => {
    setPartyModalOpen(true);
  }
  const handleAddPartyModalClose = (status) => {
    setPartyModalOpen(status);
  }

  const handlePartySave = (status) => {
    if (status) {
      dispatchGetPartyLedgerAction(partyLedgerRequestData,
        () => {
          trackDwebEvent('Dweb Parties Page', {});
          logger.log("Party Ledger", "Party Ledger Data Loading Success");
        },
        () => {
          logger.log("Party Ledger", "Party Ledger Data Loading Failure");
        }
      )
    }
  }
  const muiData = partyLedgerData;
  const muiColumns = [
    {
      name: "partyName",
      label: "Name",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          const rowIndex = tableMeta.rowIndex;
          if (rowIndex === muiData.length - 3) {
            return (
              <Fragment>
                <Waypoint
                  onEnter={() => {
                    if (user && user.partyMaxPage && user.partyMaxPage != currentPageNo) {
                      getPaginatedData()
                      setCurrentPageNo(currentPageNo + 1)
                    }
                  }}
                />
                {value}
              </Fragment>
            );
          } else {
            return <Fragment>{value}</Fragment>;
          }
        }
      },
    },
    {
      name: "contactNumber",
      label: "Mobile Number",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "activeTripsCount",
      label: "Active Trips Count",
      options: {
        filter: false,
        sort: false,
      },
    },
    // {
    //   name: "pendingPOD",
    //   label: "Pending POD",
    //   options: {
    //     filter: true,
    //     sort: false,
    //     customBodyRender: (value, tableMeta, updateValue) => {
    //       return <span>{value?value:'N/A'}</span>
    //     }
    //   },
    // },
    {
      name: "partyBalance",
      label: "Party Balance",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return <span className={classes.balance}>{numberFormat(Number(value))}</span>
        }
      },
    }
  ];
  const options = {
    rowsPerPage: 100,
    pagination: false,
    rowsPerPageOptions: [10, 100, 250],
    filterType: "multiselect",
    fixedHeader: true,
    tableBodyHeight: tableHeightWithSparkline,
    selectableRows: 'none',
    searchOpen: true,
    search: false,
    jumpToPage: false,
    download: false,
    filter: false,
    print: false,
    viewColumns: false,
    onRowClick: (rowData, rowMeta) => {
      goToPartyView(muiData[rowMeta.dataIndex])
    },
    customToolbar: (data) => {
      return <>

      </>
    },
    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {

    },
    searchProps: {
      variant: "outlined",
      //value: searchText,
      InputProps: {
        startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
      },
      onBlur: (e) => {
      },
      onKeyUp: (e) => {
      },
      onKeyDown: (event) => {
        if (event.keyCode === 27) {
        }
      }
    },
    searchPlaceholder: 'Search Parties',
    onSearchChange: (val) => {
      let value = val ? !val.replace(/\s/g, '').length ? val.trim() : val : "";
      setSearchText(value);
      if (value && value.length > 1) {
        onSearchBlur(value);
        setPartyLedgerData([]);
        setLoadingText("Loading........");
      } else if (searchText && value && value.trim().length <= 1) {
        setSearchText("");
        onSearchBlur("")
      } else {
        setSearchText("");
        onSearchBlur("")
      }
    },
    onSearchClose: () => {
    },
    customSearch: (searchQuery, currentRow, columns) => {
      let isFound = false;
      /*if (searchQuery && searchQuery.trim().length > 0) {
        searchQuery = searchQuery.trim()
        currentRow.forEach(col => {
          if (col && col.toString().toUpperCase().indexOf(searchQuery.toUpperCase()) >= 0) {
            isFound = true;
          }
        });
      } else {
        isFound = true;
      }*/
      return true;
    },
    textLabels: {
      body: {
        noMatch: loadingText,
        toolTip: "Sort",
        columnHeaderTooltip: column => `Sort for ${column.label}`
      }
    }
  };

  const handleUamClose = () => {
    setUamDialogOpen(false)
  }

  return (<Wrapper>
    <Paper className={classes.pageContentDIv} elevation={3}>
      <Grid container justify="flex-start" spacing={3} direction="row" alignItems="center">
        <Grid item>
          <TopCard title='Total Party Balance' infoTitle='Total Party Balance' infoText='The total balance amount to be collected from all your parties'
            color="#0033cc" infoIcon={true} cardValue={numberFormat(user && user.sparklineTotalBalance && user.sparklineTotalBalance.party_balance ? user.sparklineTotalBalance.party_balance : 0)} />
        </Grid>
        <Grid item>
          <TopCard title='Total Active Trips' infoTitle='Total Active Trips' infoText='The total number of trips with a balance amount from party' color="#00875a" infoIcon={true} cardValue={user && user.sparklineTotalBalance && user.sparklineTotalBalance.partyActiveTrips ? user.sparklineTotalBalance.partyActiveTrips : 0} />
        </Grid>
      </Grid>
      <MUIDataTable title={""} data={muiData} columns={muiColumns} options={options} />
    </Paper>
    {addPartyModalOpen && <AddParty open={addPartyModalOpen} onClose={handleAddPartyModalClose} onSave={handlePartySave} />}

    {uamDialogOpen && <UamPopUp open={uamDialogOpen} onClose={handleUamClose} />}

  </Wrapper >);
};
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
  dispatchLogoutAction: () => dispatch(logoutUser()),
  dispatchGetSparklineBalances: (onSuccess, onFailure) => {
    dispatch(getSparklineTotalBalances(onSuccess, onFailure))
  },
  dispatchGetPartyLedgerAction: (requestData, onSuccess, onFailure) => {
    dispatch(getPartyLedgerData(requestData, onSuccess, onFailure))
  },
});
const PartiesWithRouter = withRouter(Parties);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PartiesWithRouter);